import { useContext, useEffect } from 'react'
import { Box } from '@material-ui/core'
import { useNavigate, useParams } from 'react-router-dom'
import { PerformanceContext } from 'src/context/performance'
import { ReportsTab } from 'src/components'

const TopChart = (): JSX.Element => {
  const navigate = useNavigate()
  const params: any = useParams()
  const { state, dispatch } = useContext(PerformanceContext)

  const handleChange = (newValue: string) => {
    dispatch({
      type: 'chartType',
      payload: newValue,
    })
    navigate(`/dash/performance/${newValue}`)
  }
  useEffect(() => {
    if (params.tab) {
      dispatch({
        type: 'chartType',
        payload: params.tab,
      })
    }
    // eslint-disable-next-line
  }, [])

  // returns
  return (
    <Box width="100%">
      <ReportsTab
        value={state.chartType}
        options={state.chartTabData}
        onChange={handleChange}
      />
    </Box>
  )
}

export default TopChart
